import { createSelector } from "reselect";

export const getIsLogined = createSelector([({ authReducer }) => authReducer], (authReducer) => {
  return authReducer.isLogined;
});
